import React from 'react';
import { ExternalLink } from '../../components';

function DataPrivacyGreek() {
  return (
    <div style={{ lineHeight: '1.6', padding: '20px' }}>
      <h1 style={{ fontSize: '46px !important', lineHeight: '46px !important' }}>
        ΠΑΡΑΡΤΗΜΑ 1: ΣΥΜΦΩΝΗΤΙΚΟ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ (DATA PROCESSING ADDENDUM – “DPA”)
      </h1>

      <p>
        Το παρόν Συμφωνητικό Επεξεργασίας Δεδομένων («DPA») αποτελεί το Παράρτημα 1 και αναπόσπαστο
        μέρος των Όρων Χρήσης της Ιστοσελίδας («Συμφωνία»).
      </p>

      <p>
        ΜΕΤΑΞΥ:
        <br />
        1. Της εταιρείας «VIVIANLAB LTD», με έδρα 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1,
        VAT BG207933919 (εφεξής η «Εταιρεία» ή «VivianLab»),
        <br />
        ΚΑΙ
        <br />
        2. Του Επαγγελματία – Παρόχου – Χρήστη (εφεξής ο «Πάροχος» ή «Πελάτης»), ο οποίος έχει
        αποδεχθεί τη Συμφωνία.
        <br />
        (εφεξής τα δύο μέρη από κοινού «Μέρη» και έκαστο εξ αυτών «Μέρος»)
      </p>

      <h3>ΠΡΟΟΙΜΙΟ</h3>
      <p>
        (A) Ο Πελάτης έχει αποδεχθεί τη Συμφωνία σχετικά με την παροχή υπηρεσιών μεσολάβησης από την
        Εταιρεία μέσω της Πλατφόρμας («Υπηρεσίες»).
        <br />
        (B) Το παρόν DPA αποτελεί μέρος της Συμφωνίας και αποτυπώνει τη συμφωνία των Μερών ως προς
        την επεξεργασία Προσωπικών Δεδομένων, σύμφωνα με τις απαιτήσεις της Νομοθεσίας Προστασίας
        Δεδομένων.
        <br />
        (C) Κατά την παροχή των Υπηρεσιών στον Πελάτη, η Εταιρεία θα Επεξεργάζεται Προσωπικά
        Δεδομένα για λογαριασμό του Πελάτη. Ο Πελάτης ενεργεί ως Υπεύθυνος Επεξεργασίας και η
        Εταιρεία ως Εκτελών την Επεξεργασία.
        <br />
        (D) Τα είδη των Προσωπικών Δεδομένων και οι κατηγορίες των Υποκειμένων των Δεδομένων που
        Επεξεργάζεται η Εταιρεία ως Εκτελών την Επεξεργασία καθορίζονται λεπτομερώς στο Παράρτημα 1
        του παρόντος.
      </p>

      <h3>ΣΥΜΦΩΝΗΘΕΝΤΕΣ ΟΡΟΙ</h3>

      <p>
        1. Ερμηνεία
        <br />
        1.1 Ορισμοί και κανόνες ερμηνείας
        <br />
        Οι ακόλουθοι όροι έχουν την έννοια που τους αποδίδεται κατωτέρω:
        <br />
        «Συνδεδεμένη Εταιρεία (Affiliate)»: κάθε οντότητα που άμεσα ή έμμεσα Ελέγχει, Ελέγχεται από
        ή τελεί υπό κοινό Έλεγχο με ένα νομικό πρόσωπο.
        <br />
        «Επαγγελματικά Στοιχεία Επικοινωνίας (Business Contact Data)»: Προσωπικά Δεδομένα που
        περιέχουν επαγγελματικά στοιχεία επικοινωνίας προσωπικού των Μερών.
        <br />
        «Δεδομένα Πελάτη (Client Data)»: Προσωπικά Δεδομένα που Επεξεργάζονται στο πλαίσιο των
        Υπηρεσιών και τα οποία:
        <br />
        (α) τίθενται στη διάθεση της Εταιρείας από τον Πελάτη ή τρίτο πρόσωπο κατ’ εντολή του, ή
        <br />
        (β) συλλέγονται από την Εταιρεία για λογαριασμό του Πελάτη.
        <br />
        «Έλεγχος (Control)»: η άμεση ή έμμεση δυνατότητα καθορισμού της διοίκησης ή πολιτικών άλλου
        νομικού προσώπου.
        <br />
        «Υπεύθυνος Επεξεργασίας», «Εκτελών την Επεξεργασία», «Υποκείμενο των Δεδομένων»,
        «Επεξεργασία», «Επεξεργάζομαι»: έχουν το νόημα που τους αποδίδει ο GDPR.
        <br />
        «Νομοθεσία Προστασίας Δεδομένων»: ο Κανονισμός (ΕΕ) 2016/679 («GDPR») και η σχετική εθνική
        νομοθεσία, όπως εκάστοτε ισχύει.
        <br />
        «Τυποποιημένες Συμβατικές Ρήτρες της Ευρωπαϊκής Επιτροπής»: οι εγκεκριμένες ρήτρες για
        διαβίβαση δεδομένων εκτός ΕΟΧ (απόφαση 4.6.2021).
        <br />
        «Προσωπικά Δεδομένα»: τα δεδομένα κατά την έννοια του GDPR τα οποία (α) παρέχονται στην
        Εταιρεία από τον Πελάτη ή τρίτο για λογαριασμό του, ή (β) συλλέγονται/δημιουργούνται από την
        Εταιρεία για την εκτέλεση των Υπηρεσιών, για τα οποία ο Πελάτης είναι Υπεύθυνος
        Επεξεργασίας.
        <br />
        «Αρχή Προστασίας (Regulator)»: η αρμόδια εποπτική αρχή προστασίας δεδομένων.
        <br />
        «Παραβίαση Ασφαλείας (Security Breach)»: κάθε παραβίαση που οδηγεί σε καταστροφή, απώλεια,
        μεταβολή, μη εξουσιοδοτημένη κοινολόγηση ή πρόσβαση σε Προσωπικά Δεδομένα.
        <br />
        «Υποεκτελών την Επεξεργασία (Sub-Processor)»: κάθε τρίτο μέρος που συμβάλλεται με την
        Εταιρεία για την επεξεργασία των Δεδομένων Πελάτη.
        <br />
        «Τεχνικά και Οργανωτικά Μέτρα»: τα μέτρα του άρθρου 32 GDPR.
        <br />
        1.2 Τα Παραρτήματα αποτελούν αναπόσπαστο μέρος του παρόντος DPA.
        <br />
        1.3 Σε περίπτωση σύγκρουσης μεταξύ του παρόντος DPA και της Συμφωνίας, υπερισχύει το παρόν
        DPA.
      </p>

      <p>
        2. ΕΠΕΞΕΡΓΑΣΙΑ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ
        <br />
        2.1 Ρόλοι των Μερών
        <br />
        (a) Τα Μέρη αναγνωρίζουν και συμφωνούν ότι, όσον αφορά την Επεξεργασία Προσωπικών Δεδομένων:
        <br />
        ο Πελάτης (Πάροχος) ενεργεί ως Υπεύθυνος Επεξεργασίας,
        <br />
        η Εταιρεία (VivianLab) ενεργεί ως Εκτελών την Επεξεργασία,
        <br />
        και η Εταιρεία δύναται να χρησιμοποιεί Υποεκτελούντες την Επεξεργασία, σύμφωνα με το άρθρο 4
        κατωτέρω.
        <br />
        <br />
        2.2 Επεξεργασία Προσωπικών Δεδομένων από τον Πελάτη
        <br />
        (a) Ο Πελάτης οφείλει να Επεξεργάζεται Προσωπικά Δεδομένα στο πλαίσιο των Υπηρεσιών σύμφωνα
        με τη Νομοθεσία Προστασίας Δεδομένων.
        <br />
        (b) Οι οδηγίες του Πελάτη προς την Εταιρεία για την Επεξεργασία πρέπει να συμμορφώνονται με
        τον GDPR και την εθνική νομοθεσία.
        <br />
        (c) Ο Πελάτης φέρει πλήρη ευθύνη για:
        <br />
        την ακρίβεια,
        <br />
        την ποιότητα,
        <br />
        τη νομιμότητα
        <br />
        των Δεδομένων Πελάτη και του τρόπου απόκτησής τους.
        <br />
        (d) Ο Πελάτης εγγυάται και δηλώνει ότι:
        <br />
        (i) η κοινολόγηση Προσωπικών Δεδομένων προς την Εταιρεία περιορίζεται στο απολύτως
        απαραίτητο για την εκτέλεση των Υπηρεσιών,
        <br />
        (ii) τα Προσωπικά Δεδομένα είναι ακριβή και επικαιροποιημένα κατά τον χρόνο παροχής τους
        στην Εταιρεία,
        <br />
        (iii) έχει και θα διατηρεί έγκυρη νομική βάση επεξεργασίας (περιλαμβανομένης ρητής
        συγκατάθεσης όπου απαιτείται βάσει άρθρου 9 GDPR για ευαίσθητα δεδομένα),
        <br />
        έχει πραγματοποιήσει όπου απαιτείται εκτίμηση έννομου συμφέροντος,
        <br />
        και θα διατηρεί τις απαραίτητες ενημερώσεις και γνωστοποιήσεις προς τα Υποκείμενα των
        Δεδομένων.
        <br />
        <br />
        2.3 Επεξεργασία Προσωπικών Δεδομένων από την Εταιρεία
        <br />
        (a) Η Εταιρεία θα Επεξεργάζεται Προσωπικά Δεδομένα σύμφωνα με:
        <br />
        τη Νομοθεσία Προστασίας Δεδομένων και
        <br />
        τις γραπτές οδηγίες του Πελάτη, οι οποίες περιλαμβάνουν τη Συμφωνία και τη χρήση των
        Υπηρεσιών.
        <br />
        (b) Η Εταιρεία εξουσιοδοτείται να Επεξεργάζεται Προσωπικά Δεδομένα για τους σκοπούς που
        περιγράφονται στο Παράρτημα 1.
        <br />
        (c) Αν η Εταιρεία θεωρήσει εύλογα ότι οδηγία του Πελάτη παραβιάζει τον GDPR ή άλλη σχετική
        νομοθεσία, θα ενημερώσει τον Πελάτη χωρίς καθυστέρηση.
        <br />
        (d) Η Εταιρεία θα διασφαλίζει ότι κάθε φυσικό πρόσωπο που εξουσιοδοτείται να Επεξεργάζεται
        Προσωπικά Δεδομένα:
        <br />
        δεσμεύεται από υποχρέωση εμπιστευτικότητας, και
        <br />
        δεν θα γνωστοποιεί Προσωπικά Δεδομένα σε τρίτους χωρίς προηγούμενη γραπτή άδεια του Πελάτη,
        εκτός εάν απαιτείται από τον νόμο ή επιτρέπεται από τη Συμφωνία.
      </p>

      <p>
        3. ΔΙΚΑΙΩΜΑΤΑ ΥΠΟΚΕΙΜΕΝΩΝ ΔΕΔΟΜΕΝΩΝ
        <br />
        3.1 Διόρθωση, Δέσμευση και Διαγραφή
        <br />
        (a) Η Εταιρεία, στο μέτρο που το επιτρέπει ο νόμος, θα ενημερώνει τον Πελάτη σε περίπτωση
        που λάβει καταγγελία ή αίτημα σχετικό με τις υποχρεώσεις του Πελάτη βάσει της Νομοθεσίας
        Προστασίας Δεδομένων.
        <br />
        (b) Η Εταιρεία, με δαπάνη του Πελάτη, θα συμμορφώνεται με κάθε εμπορικά εύλογη γραπτή οδηγία
        του Πελάτη για τη διευκόλυνση οποιασδήποτε ενέργειας απαιτείται.
        <br />
        <br />
        3.2 Αιτήματα Υποκειμένων Δεδομένων
        <br />
        (a) Η Εταιρεία θα ενημερώνει άμεσα τον Πελάτη, κατά το δυνατόν και επιτρεπτό από τον νόμο,
        εάν λάβει αίτημα από Υποκείμενο των Δεδομένων για:
        <br />
        πρόσβαση,
        <br />
        διόρθωση,
        <br />
        τροποποίηση,
        <br />
        περιορισμό ή
        <br />
        διαγραφή
        <br />
        των Δεδομένων του.
        <br />
        (b) Η Εταιρεία δεν θα απαντήσει σε τέτοιο αίτημα χωρίς προηγούμενη γραπτή άδεια του Πελάτη,
        εκτός για να επιβεβαιώσει ότι το αίτημα διαβιβάστηκε στον Πελάτη.
        <br />
        (c) Η Εταιρεία θα παρέχει στον Πελάτη κάθε εμπορικά εύλογη υποστήριξη για τη διαχείριση του
        αιτήματος, εφόσον ο Πελάτης δεν έχει ο ίδιος τη δυνατότητα να προβεί στην ενέργεια.
        <br />
        (d) Ο Πελάτης ευθύνεται για κάθε τεκμηριωμένη δαπάνη σχετική με την παροχή της υποστήριξης
        αυτής.
      </p>

      <p>
        4. ΥΠΟΕΚΤΕΛΟΥΝΤΕΣ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ
        <br />
        4.1 Ορισμός Υποεκτελούντων
        <br />
        (a) Ο Πελάτης αναγνωρίζει και συμφωνεί ότι η Εταιρεία δύναται να αναθέτει σε τρίτους
        Υποεκτελούντες την Επεξεργασία Προσωπικών Δεδομένων στο πλαίσιο της παροχής των Υπηρεσιών.
        <br />
        Οι τρέχοντες Υποεκτελούντες της Εταιρείας παρατίθενται στην{' '}
        <ExternalLink href="/privacy-policy">Πολιτική Απορρήτου</ExternalLink> ή/και παρέχονται
        κατόπιν αιτήματος του Πελάτη.
        <br />
        (b) Η Εταιρεία υποχρεούται να διασφαλίζει ότι όλοι οι Υποεκτελούντες δεσμεύονται εγγράφως να
        Επεξεργάζονται Προσωπικά Δεδομένα σύμφωνα με όρους τουλάχιστον ισοδύναμους με τους όρους της
        παρούσας DPA.
        <br />
        <br />
        4.2 Ευθύνη Υποεκτελούντων
        <br />
        (a) Η Εταιρεία ευθύνεται έναντι του Πελάτη για τις πράξεις και παραλείψεις των
        Υποεκτελούντων κατά την Επεξεργασία, όπως ακριβώς θα ευθυνόταν αν ενεργούσε η ίδια.
      </p>

      <p>
        5. ΑΣΦΑΛΕΙΑ ΚΑΙ ΓΝΩΣΤΟΠΟΙΗΣΗ ΠΑΡΑΒΙΑΣΗΣ
        <br />
        Η Εταιρεία θα συνεργάζεται, κατόπιν αιτήματος, με κάθε αρμόδια εποπτική αρχή, παρέχοντας
        όλες τις πληροφορίες και συνδρομή που απαιτούνται σύμφωνα με τη Νομοθεσία Προστασίας
        Δεδομένων, συμπεριλαμβανομένου του άρθρου 31 GDPR.
        <br />
        Η Εταιρεία θα εφαρμόζει και θα διατηρεί κατάλληλα τεχνικά και οργανωτικά μέτρα, σύμφωνα με
        το άρθρο 32 GDPR, τα οποία δύνανται να περιλαμβάνουν:
        <br />
        ψευδωνυμοποίηση και κρυπτογράφηση,
        <br />
        μηχανισμούς ελέγχου πρόσβασης,
        <br />
        διαδικασίες δημιουργίας αντιγράφων ασφαλείας,
        <br />
        τακτικές δοκιμές ασφάλειας.
        <br />
        Σε περίπτωση Παραβίασης Προσωπικών Δεδομένων, η Εταιρεία θα ενημερώνει τον Πελάτη χωρίς
        αδικαιολόγητη καθυστέρηση και θα παρέχει όλες τις απαραίτητες πληροφορίες ώστε ο Πελάτης να
        συμμορφωθεί με τα άρθρα 33 και 34 GDPR.
      </p>

      <p>
        6. ΕΙΔΟΠΟΙΗΣΕΙΣ
        <br />Η Εταιρεία θα ενημερώνει άμεσα τον Πελάτη για κάθε νόμιμο αίτημα γνωστοποίησης
        Προσωπικών Δεδομένων από εποπτική αρχή, αρχή επιβολής του νόμου ή άλλη δημόσια αρχή, εκτός
        όταν απαγορεύεται από τον νόμο.
      </p>

      <p>
        7. ΕΠΙΣΤΡΟΦΗ ΚΑΙ ΔΙΑΓΡΑΦΗ ΔΕΔΟΜΕΝΩΝ
        <br />
        7.1 Διαγραφή ή Επιστροφή
        <br />
        Κατά τη λήξη ή καταγγελία των Υπηρεσιών, ή κατόπιν γραπτού αιτήματος του Πελάτη, η Εταιρεία
        θα:
        <br />
        διαγράψει, ή
        <br />
        επιστρέψει
        <br />
        όλα τα Προσωπικά Δεδομένα, εκτός εάν η διατήρηση απαιτείται για νομικούς ή κανονιστικούς
        λόγους.
        <br />
        7.2 Διαγραφή
        <br />
        Εάν ο Πελάτης επιλέξει διαγραφή, η Εταιρεία θα διαγράψει τα Προσωπικά Δεδομένα χωρίς
        αδικαιολόγητη καθυστέρηση, εκτός αν η νομοθεσία απαιτεί τη διατήρησή τους.
        <br />
        7.3 Πιστοποίηση Διαγραφής
        <br />
        Πιστοποίηση διαγραφής θα παρέχεται μόνο κατόπιν αιτήματος του Πελάτη.
      </p>

      <p>
        8. ΕΛΕΓΧΟΙ (AUDITS) ΚΑΙ ΣΥΝΔΡΟΜΗ
        <br />
        8.1 Διαθεσιμότητα Πληροφοριών
        <br />
        Η Εταιρεία θα παρέχει, κατόπιν αιτήματος, κάθε απαραίτητη πληροφορία για να αποδείξει τη
        συμμόρφωση με την παρούσα DPA.
        <br />
        8.2 Δικαίωμα Ελέγχου
        <br />
        Ο Πελάτης δικαιούται να διενεργεί ελέγχους, υπό τις εξής προϋποθέσεις:
        <br />
        (a) Ο έλεγχος ζητείται εγγράφως και όχι συχνότερα από μία φορά ανά 12 μήνες.
        <br />
        (b) Ο έλεγχος πραγματοποιείται εντός των συνήθων εργάσιμων ωρών και χωρίς υπερβολική
        διατάραξη της λειτουργίας της Εταιρείας.
        <br />
        (c) Απαιτείται υποβολή αναλυτικού σχεδίου ελέγχου 6 εβδομάδες πριν.
        <br />
        (d) Το κόστος του ελέγχου βαρύνει αποκλειστικά τον Πελάτη.
        <br />
        8.3 Συνδρομή σε DPIA
        <br />
        Η Εταιρεία θα παρέχει υποστήριξη για:
        <br />
        εκπόνηση DPIA (εκτίμηση αντικτύπου),
        <br />
        διαβούλευση με εποπτική αρχή,
        <br />
        μόνο εφόσον υπάρχει γραπτό αίτημα και με κόστος του Πελάτη.
      </p>

      <p>
        9. ΜΕΤΑΦΟΡΕΣ ΔΕΔΟΜΕΝΩΝ ΕΚΤΟΣ ΕΟΧ
        <br />
        9.1 Απαίτηση Άδειας
        <br />
        Η Εταιρεία δεν θα μεταφέρει Προσωπικά Δεδομένα εκτός ΕΟΧ χωρίς:
        <br />
        προηγούμενη γραπτή άδεια του Πελάτη, και
        <br />
        νόμιμο μηχανισμό μεταφοράς (π.χ. SCCs).
        <br />
        9.2 Γενική Άδεια
        <br />Ο Πελάτης παρέχει γενική άδεια για μεταφορές σε Υποεκτελούντες εκτός ΕΟΧ, υπό την
        προϋπόθεση ότι εφαρμόζεται έγκυρος μηχανισμός μεταφοράς.
      </p>

      <p>
        10. ΕΥΘΥΝΗ ΚΑΙ ΑΠΟΖΗΜΙΩΣΗ
        <br />
        10.1 Μη υπαγωγή σε περιορισμούς της κύριας Συμφωνίας
        <br />
        Οι περιορισμοί ευθύνης της κύριας Συμφωνίας δεν εφαρμόζονται στο παρόν Παράρτημα, εκτός αν
        ορίζεται ρητώς.
        <br />
        10.2 Αποκλεισμός ορισμένων ζημιών
        <br />
        Κανένα μέρος δεν ευθύνεται για:
        <br />
        απώλεια εισοδήματος ή κερδών,
        <br />
        απώλεια συμβολαίων,
        <br />
        ειδικές, έμμεσες ή παρεπόμενες ζημίες.
        <br />
        10.3 Ανώτατο Όριο Ευθύνης
        <br />
        Με την επιφύλαξη της ρήτρας 10.1, η συνολική σωρευτική ευθύνη της Εταιρείας έναντι του
        Παρόχου, η οποία απορρέει από ή συνδέεται με το παρόν DPA — ανεξαρτήτως νομικής βάσης
        (συμβατικής, αδικοπρακτικής, παράβασης νόμιμης υποχρέωσης, αποζημίωσης ή άλλης αιτίας) δεν
        θα υπερβαίνει σε καμία περίπτωση το συνολικό ποσό των τριών χιλιάδων ευρώ (€3.000).από τον
        Πελάτη κατά τους προηγούμενους δώδεκα (12) μήνες.
        <br />
        10.4 Αποζημίωση από την Εταιρεία
        <br />
        Η Εταιρεία θα αποζημιώνει τον Πελάτη για ζημίες ή πρόστιμα που προκύπτουν άμεσα από
        παραβίαση της παρούσας DPA από την Εταιρεία.
        <br />
        10.5 Αποζημίωση από τον Πελάτη
        <br />
        Ο Πελάτης θα αποζημιώνει την Εταιρεία για ζημίες, πρόστιμα ή απαιτήσεις που προκύπτουν από:
        <br />
        (α) την συμμόρφωση της Εταιρείας με οδηγίες του Πελάτη σχετικά με την Επεξεργασία,
        <br />
        (b) παραβίαση των υποχρεώσεων του Πελάτη ως Υπεύθυνου Επεξεργασίας.
        <br />
        10.6 Εφαρμογή του ορίου ευθύνης σε όλες τις αξιώσεις
        <br />
        Οι περιορισμοί και εξαιρέσεις ευθύνης του παρόντος άρθρου 10 εφαρμόζονται σε όλες τις
        αξιώσεις, συμπεριλαμβανομένων των αξιώσεων αποζημίωσης (indemnity claims), εκτός εάν και
        στον βαθμό που τέτοιος περιορισμός απαγορεύεται ρητώς από υποχρεωτικές διατάξεις νόμου.
      </p>

      <p>
        11. ΕΝΝΟΜΗ ΙΣΧΥΣ
        <br />
        Η παρούσα DPA καθίσταται δεσμευτική από την ημερομηνία σύναψης της Κύριας Συμφωνίας.
        <br />
        Οι διατάξεις της παραμένουν σε ισχύ μέχρι την επιστροφή ή διαγραφή όλων των Προσωπικών
        Δεδομένων.
      </p>

      <p>
        12. ΓΕΝΙΚΟΙ ΟΡΟΙ
        <br />
        Το παρόν Παράρτημα και η κύρια Συμφωνία αποτελούν ολόκληρη τη συμφωνία των Μερών ως προς το
        αντικείμενο.
        <br />
        Το εφαρμοστέο δίκαιο είναι το Ελληνικό Δίκαιο.
        <br />
        Αποκλειστική δικαιοδοσία: Τα Δικαστήρια Αθηνών.
      </p>

      <h3>ΠΑΡΑΡΤΗΜΑ 1 – Περιγραφή Επεξεργασίας Προσωπικών Δεδομένων</h3>
      <p>
        Αντικείμενο:
        <br />
        Η παροχή υπηρεσιών διαμεσολάβησης μέσω της Πλατφόρμας VivianLab, επιτρέποντας στον Πάροχο να
        διαχειρίζεται ραντεβού και συνεδρίες με τους Χρήστες του.
        <br />
        <br />
        Φύση της Επεξεργασίας:
        <br />
        Συλλογή, αποθήκευση, ανάκτηση και διαχείριση δεδομένων Χρηστών για:
        <br />
        προγραμματισμό υπηρεσιών,
        <br />
        επεξεργασία πληρωμών,
        <br />
        επικοινωνία και παροχή συνεδριών.
        <br />
        <br />
        Σκοπός:
        <br />
        Η εκτέλεση της Συμφωνίας και η παροχή επαγγελματικών υπηρεσιών από τον Πάροχο στα Υποκείμενα
        των Δεδομένων.
        <br />
        <br />
        Κατηγορίες Δεδομένων:
        <br />
        (a) Στοιχεία Ταυτότητας &amp; Επικοινωνίας
        <br />
        Όνομα, Επώνυμο
        <br />
        Email
        <br />
        Τηλέφωνο
        <br />
        (b) Δεδομένα Ραντεβού &amp; Υπηρεσιών
        <br />
        Ημερομηνία, ώρα, κατάσταση ραντεβού
        <br />
        Δεδομένα από Google Calendar (εφόσον ο Χρήστης χρησιμοποιεί διασύνδεση)
        <br />
        Στοιχεία υπηρεσίας, επικοινωνία, σημειώσεις χρήστη, παράπονα
        <br />
        Ευαίσθητα Δεδομένα (Special Categories)
        <br />
        Δεδομένα υγείας, συμπτώματα, ιατρικές πληροφορίες που παρέχονται στον Πάροχο.
        <br />
        Ο Πάροχος είναι αποκλειστικά υπεύθυνος για έγκυρη νομική βάση (άρθρο 9 GDPR).
        <br />
        <br />
        Υποκείμενα Δεδομένων:
        <br />
        Χρήστες/ασθενείς του Παρόχου.
        <br />
        <br />
        Αποδέκτες (Υποεκτελούντες):
        <br />
        Υποδομές Cloud (AWS, Render)
        <br />
        Πάροχοι Πληρωμών
        <br />
        Analytics (Google Analytics)
        <br />
        Εργαλεία επικοινωνίας και marketing
        <br />
        <br />
        Διαβιβάσεις εκτός ΕΟΧ:
        <br />
        Επιτρέπονται μόνο με νόμιμο μηχανισμό (π.χ. SCCs).
        <br />
        <br />
        Αποθήκευση &amp; Διαγραφή:
        <br />
        Διαγραφή εντός 3 ετών από τη λήξη της Συμφωνίας, εκτός αν απαιτείται διαφορετικά από τον
        νόμο.
      </p>
    </div>
  );
}

export default DataPrivacyGreek;
